import React from 'react';

const Processing = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <p>
          We produce refined metals by processing and smelting extracted minerals at our zinc, lead, silver, copper, and
          aluminium smelters, and other processing facilities in India and Africa. For this purpose, we generate captive
          power as a best practice measure and sell any surplus power.
        </p>
      </div>
    </div>
  );
};

export default Processing;
